import { SORT_INBOX_KEYS } from '@/entities/inbox';

export const SORT_BY_DATES = [SORT_INBOX_KEYS.NEW_TO_OLD, SORT_INBOX_KEYS.OLD_TO_NEW];

export const SORT_INBOX_TEXT = {
  NEW_TO_OLD: 'Newest to oldest',
  OLD_TO_NEW: 'Oldest to newest',
  HIGH_TO_LOW: 'Highest to lowest',
  LOW_TO_HIGH: 'Lowest to highest',
};

export const SORT_INBOX_TOOLTIP_TEXT = {
  [SORT_INBOX_KEYS.NEW_TO_OLD]: 'Date: Newest to oldest, click to change',
  [SORT_INBOX_KEYS.OLD_TO_NEW]: 'Date: Oldest to newest, click to change',
  [SORT_INBOX_KEYS.HIGH_TO_LOW]: 'Priority: Highest to lowest, click to change',
  [SORT_INBOX_KEYS.LOW_TO_HIGH]: 'Priority: Lowest to highest, click to change',
};
